// extracted by mini-css-extract-plugin
export var accent = "TextArea-module--accent--72640";
export var textarea = "TextArea-module--textarea--10a62";